import React from "react";
import { Wrapper, Row, Column, CopyWrapper } from "./index.styled";
import Copy from "components/copy";
import Button from "components/ui/button";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

const InfoSection = ({ data }) => {
  const { copyContent, link, images } = data;
  return (
    <Wrapper id="club-owner-program">
      <Row>
        <Column $mobilePadding="copyLeft">
          <CopyWrapper>
            <Copy data={copyContent} />
            <Button link={link}>EXPLORE</Button>
          </CopyWrapper>
        </Column>
        <Column $mobilePadding="imageLeft">
          <GatsbyImage image={getImage(images[0]?.file)} alt="" />
        </Column>
      </Row>
    </Wrapper>
  );
};

export default InfoSection;
